import Swiper from 'swiper';
import {Autoplay} from 'swiper/modules';

export function blockquoteSwiper() {
    const carousels = document.querySelectorAll('.blockquote-carousel');

    function updateButtonColor(carousel, selector, color) {
        const buttons = carousel.querySelectorAll(selector);
        if (buttons) {
            buttons.forEach((button) => {
                button.style.fill = color;
            });
        }
    }

    function setButtonDisabled(carousel, selector, setDisabled) {
        const buttons = carousel.querySelectorAll(selector);
        if (buttons) {
            buttons.forEach((button) => {
                if (setDisabled) {
                    button.setAttribute('disabled', '');
                } else {
                    button.removeAttribute('disabled');
                }
            });
        }
    }

    // Loop through each carousel and initialize Swiper
    carousels.forEach((carousel) => {
        const carouselWrapper = carousel.querySelector('.swiper.cards-carousel-vertical');
        const isDarkBackground = carousel.dataset.mode.match(/dark/i);
        const isAutoplayEnabled = carousel.classList.contains('autoplay-enabled');
        const isSliderHorizontal = carousel.classList.contains('slider--horizontal');
        const themeArrowColour = isDarkBackground ? '#fff' : '#060D32';
        const slidesCount = carousel.querySelectorAll('.swiper-slide').length;

        // Define base modules (like Navigation, Pagination)
        let swiperModules = [];

        // Conditionally add Autoplay if the class exists
        if (isAutoplayEnabled) {
            swiperModules.push(Autoplay);
        }

        if (!carouselWrapper) return;

        if (slidesCount >= 2) {
            const swiper = new Swiper(carouselWrapper, {
                modules: swiperModules,
                autoplay: isAutoplayEnabled
                    ? {
                          delay: 5000,
                      }
                    : false,
                direction: isSliderHorizontal ? 'horizontal' : 'vertical',
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                a11y: {
                    slideRole: '',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    569: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    841: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    1200: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    1500: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    1921: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                },
                on: {
                    slideChange: function () {
                        const slidesPerView = swiper.params.slidesPerView;
                        const totalSlides = swiper.slides.length;

                        const isFirstSlide = swiper.activeIndex === 0 && !swiper.params.loop;
                        // Showing two cards at a time
                        const isLastSlide = swiper.activeIndex >= totalSlides - slidesPerView && !swiper.params.loop;

                        updateButtonColor(carousel, '.swiper-button-prev svg path', isFirstSlide ? '#b9bdc8' : themeArrowColour);
                        updateButtonColor(carousel, '.swiper-button-next svg path', isLastSlide ? '#b9bdc8' : themeArrowColour);

                        if (isFirstSlide) {
                            setButtonDisabled(carousel, '.swiper-button-prev', true);
                        } else {
                            setButtonDisabled(carousel, '.swiper-button-prev', false);
                        }

                        if (isLastSlide) {
                            setButtonDisabled(carousel, '.swiper-button-next', true);
                        } else {
                            setButtonDisabled(carousel, '.swiper-button-next', false);
                        }
                    },
                },
            });

            const swiperPrev = carousel.querySelectorAll('.swiper-button-prev');
            const swiperNext = carousel.querySelectorAll('.swiper-button-next');

            const prevButtonPaths = carousel.querySelectorAll('.swiper-button-prev svg path');
            const color = swiper.realIndex === 0 && !swiper.params.loop ? '#b9bdc8' : themeArrowColour;

            prevButtonPaths.forEach((path) => {
                path.style.fill = color;
            });

            swiperPrev.forEach((prev) => {
                slidesCount < 2 ? (prev.style.display = 'none') : ``;
                prev.addEventListener('click', () => {
                    swiper.slidePrev();
                });
            });

            swiperNext.forEach((next) => {
                slidesCount < 2 ? (next.style.display = 'none') : '';
                next.addEventListener('click', () => {
                    swiper.slideNext();
                });
            });

            setButtonDisabled(carousel, '.swiper-button-prev', true);
        } else {
            const swiperPrev = carousel.querySelectorAll('.swiper-button-prev');
            const swiperNext = carousel.querySelectorAll('.swiper-button-next');

            swiperPrev.forEach((prev) => {
                prev.style.display = 'none';
            });

            swiperNext.forEach((next) => {
                next.style.display = 'none';
            });

            carouselWrapper.style.margin = '0 0 0 0';
        }
    });
}
